import { useLocation, useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import React, { useEffect, useState } from "react";
import { userDetails } from "../../../api/apiHandler";
import Image from "../../../user.png";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";

export default function TeacherDetails({ isLoader }) {
    const [data, setData] = useState([])
    const navigate = useNavigate()
    const location = useLocation()
    const teacherID = location.state && location.state.teacherId;
    const name = location.state && location.state.name;

    const GetTeacherData = () => {
        isLoader(true)
        userDetails({ id: teacherID }).then((resposnse) => {
            if (resposnse.code == 1) {
                setData(resposnse.data[0])
                isLoader(false)
            } else {
                setData([]);
                isLoader(false)
            }
        });
    }

    useEffect(() => {
        GetTeacherData();
    }, []);

    const handleBack = () => {
        navigate(-1);
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <header className="dashboard-toolbar d-lg-flex justify-content-between">
            <div className="align-items-center justify-content-between d-flex">
                <div className="d-flex align-items-center">
                    <a className="menu-toggle align-items-center d-lg-none d-flex">
                        <i className="fa fa-bars" />
                    </a>
                    <a href="index.php" className="d-lg-none d-block brand-logo">
                        <img src="./assets/images/logo.png" alt="logo" />
                    </a>
                </div>
            </div>
        </header>
        <section className="main_sec">
            <div className="mt-4 mx-5 mb-5">
                <div>
                    <span onClick={handleBack}>
                        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                        </svg>
                        <span className="ms-2">Back</span>
                    </span>
                </div>
                {isLoader && data.length !== 0 ? (
                    <div>
                        <p className="ms-3 fs-3 fw-500 text-center mb-3">Teacher Details</p>

                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col col-lg-7 mb-4 mb-lg-0">
                                <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                    <div className="row g-0">

                                        <div className="col-md-12">

                                            <div className="card-body p-4">

                                                <div className="gradient-custom text-center text-white mb-4">
                                                    <img src={data.profile_image ? data.profile_image : Image}
                                                        alt="Avatar" className="img-fluid mb-3" style={{ width: "100px", height: "100px", borderRadius: "50%" }} />
                                                    <p className="fs-5 fw-600 text-dark">{data.full_name}</p>
                                                </div>

                                                <h6 className="mb-2">Information</h6>
                                                <hr className="mt-0 mb-4" />
                                                <div className="row pt-1">
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-600">Email</p>
                                                        <p className="text-muted mt-1">{data.email}</p>
                                                    </div>
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-600">Phone</p>
                                                        <p className="text-muted mt-1">{data.country_code + " " + data.phone}</p>
                                                    </div>
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-600">Country</p>
                                                        <p className="text-muted mt-1">{data.country}</p>
                                                    </div>
                                                    {data.time_zone &&
                                                        <div className="col-4 mb-3">
                                                            <p className="fw-600">Time zone</p>
                                                            <p className="text-muted mt-1">{data.time_zone}</p>
                                                        </div>
                                                    }

                                                    <div className="col-4 mb-4">
                                                        <p className="fw-600">Role</p>
                                                        <p className="text-muted mt-1">{data.role}</p>
                                                    </div>
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-600">Category</p>
                                                        <p className="text-muted mt-1">{data.category}</p>
                                                    </div>
                                                    <div className="col-4 mb-4">
                                                        <p className="fw-600">Status</p>
                                                        <p className="text-muted mt-1">{data.status}</p>
                                                    </div>

                                                    {data.add_qualification &&
                                                        <div className="col-4 mb-4">
                                                            <p className="fw-600">Qualification</p>
                                                            <p className="text-muted mt-1">{data.add_qualification}</p>
                                                        </div>
                                                    }

                                                    <div className="col-4 mb-4">
                                                        <p className="fw-600">Language</p>
                                                        <p className="text-muted mt-1">{data.language}</p>
                                                    </div>

                                                    {data.about_me &&
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-600">About Me</p>
                                                            <div className="text-muted mt-1" dangerouslySetInnerHTML={{ __html: data.about_me }} />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row align-items-center justify-content-center mt-2">
                            <div className="col-lg-7 mb-4 mb-lg-0 d-flex justify-content-center">
                                <div className="d-flex justify-content-center align-items-center gap-4">
                                    <button onClick={() => navigate("/teacher-applications-details", { state: { tID: teacherID, email: data.email , name : name} })} className="btn-theme">View Teacher Applications</button>
                                    <button onClick={() => navigate("/teacher-identity-details", { state: { teachID: teacherID, email: data.email ,tName : name} })} className="btn-theme">View Identity Verification Details</button>
                                    <button onClick={() => navigate("/teacher-background-details", { state: { teacherId: teacherID, email: data.email ,teacherName : name} })} className="btn-theme">View Background Details</button>
                                    <button onClick={() => navigate("/teacher-profile", { state: { teacherId: teacherID, email: data.email ,teachName : name} })} className="btn-theme">View Teacher Profile</button>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    null
                )}
            </div>
        </section>
    </>
}

